/**
 * configuration applied when BROCOLI_API_MODE = production
 */
module.exports = {
  authMode: ['providers'],
  authOAuthProviders: [
    [
      'WSSOKeycloak',
      {
        realm: 'Carglass-radio',
        clientId: 'carglass-radio-saml',
        buttonText: 'Identification Carglass',
      },
    ],
  ],
}
